import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight, X } from "lucide-react";
import { computeClosedToday } from "@/components/OpenNowBadge";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ClosedRibbon() {
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetch(`${API}/business`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d && Array.isArray(d.hours) && d.hours.length) setInfo(computeClosedToday(d.hours));
      })
      .catch(() => {});
  }, []);

  const show = info && info.closedAllDay && !dismissed;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="closed-ribbon"
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 60 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-4 bottom-4 z-50 mx-auto max-w-xl"
        >
          <div className="flex items-center gap-4 rounded-2xl border border-[#F0A829]/50 bg-[#122A1F]/95 p-4 shadow-2xl shadow-black/50 backdrop-blur-lg">
            <div className="flex-1">
              <p className="font-display text-base font-bold uppercase tracking-wide text-[#F6F1E3]">
                We&apos;re closed today
              </p>
              <p className="mt-0.5 text-xs leading-relaxed text-[#B9C4B4]">
                Book in the app anytime — {info.nextLabel ? `or call us ${info.nextLabel}` : "or call us next opening day"}.
              </p>
            </div>
            <a
              data-testid="closed-ribbon-book-button"
              href="https://kiltedcouriers.app"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex shrink-0 items-center gap-1.5 rounded-full bg-[#F0A829] px-4 py-2.5 font-display text-xs font-bold uppercase tracking-wider text-[#0C1F17] transition-transform duration-300 hover:-translate-y-0.5"
            >
              Book in the app
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={2.5} />
            </a>
            <button
              data-testid="closed-ribbon-dismiss"
              onClick={() => setDismissed(true)}
              aria-label="Dismiss"
              className="shrink-0 rounded-full border border-white/15 p-1.5 text-[#B9C4B4] transition-colors duration-300 hover:border-[#F0A829] hover:text-[#F0A829]"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
